<template>
  <b-container class="my-3">
    <b-row>
      <b-col cols="9">
        <h1 class="display-4 text-purple">Contáctanos</h1>
        <p class="lead">Si tienes dudas o comentarios no dudes en contactarnos a travez del siguiente formulario.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="9">
        <b-form ref="form" @submit="onSubmit">
          <b-form-group id="input-group-name" label="Nombre" label-for="input-name">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon :icon="['fa', 'user']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                id="input-name"
                v-model="form.data.name"
                required
                placeholder="Ingresa tu nombre" />
            </b-input-group>
          </b-form-group>

          <b-form-group id="input-group-email" label="Email" label-for="input-email">
            <b-input-group prepend="@">
              <b-form-input
                id="input-email"
                v-model="form.data.email"
                type="email"
                required
                placeholder="Ingresa tu email" />
            </b-input-group>
          </b-form-group>

          <b-form-group id="input-group-phone" label="Teléfono" label-for="input-phone">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon :icon="['fa', 'mobile']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                id="input-phone"
                v-model="form.data.phone"
                required
                placeholder="Ingresa tu teléfono" />
            </b-input-group>
          </b-form-group>

          <b-form-group id="input-group-comments" label="Comentarios" label-for="input-comments">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon :icon="['fa', 'comment']" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-textarea
                id="input-comments"
                v-model="form.data.comments"
                required />
            </b-input-group>
          </b-form-group>

          <b-form-group id="input-group-copy">
            <b-form-checkbox v-model="form.data.copy" :unchecked-value="false" :value="true">Enviarme una copia a mi email</b-form-checkbox>
          </b-form-group>

          <button
            id="btn-submit-contact-form"
            class="btn btn-purple g-recaptcha"
            :data-sitekey="rcapt_sig_key"
            data-action='submit'
            @click="onSubmit">Enviar mensaje</button>
        </b-form>
      </b-col>
      <b-col sm="3" class="text-center">
        <ul class="list-unstyled mb-0">
          <li><font-awesome-icon size="3x" :icon="['fas', 'store']" />
            <p>Roma Norte, CDMX</p>
          </li>

          <li><font-awesome-icon size="3x" :icon="['fab', 'whatsapp']" />
            <p>+52 55 49 32 41 91</p>
          </li>

          <li><font-awesome-icon size="3x" :icon="['fas', 'envelope']" />
            <p>contacto@pamelamolina.com</p>
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-overlay :show="overlay" rounded="sm" fixed no-wrap />
  </b-container>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      overlay: false,
      rcapt_sig_key: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
      form: {
        data: {
          email: null,
          name: '',
          phone: '',
          comments: '',
          copy: false
        }
      }
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.classList.add('was-validated')
      } else {
        this.$refs.form.classList.remove('was-validated')
      }
      return valid
    },
    onSubmit (evt) {
      evt.preventDefault()
      const valid = this.checkFormValidity()
      if (!valid) return
      this.overlay = true
      window.grecaptcha.ready(async function () {
        try {
          this.overlay = true
          const token = await window.grecaptcha
            .execute(process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY, { action: 'submit' })
          this.form.data.token = token
          await this.$http.post('/contact', this.form.data)
          this.$bvToast.toast('Hemos recibido tu mensaje. Pronto nos pondremos en contacto contigo.', {
            title: 'Mensaje enviado',
            variant: 'primary'
          })
          this.form.data = { name: ' ', email: null, phone: ' ', token: null, comments: ' ' }
        } catch (error) {
          this.$bvToast.toast(error.message, {
            title: 'No se pudo enviar su mensaje',
            variant: 'danger'
          })
        } finally {
          this.overlay = false
        }
      }.bind(this))
    }
  }
}
</script>
